/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WriteOffDisputedAmountRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {WriteOffDisputedAmountResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const writeOffDisputedAmount = (request: WriteOffDisputedAmountRequest, options?: CashRequestOptions) => post<WriteOffDisputedAmountRequest, WriteOffDisputedAmountResponse>("/2.0/cash/write-off-disputed-amount", request, {...options, rejectOnError: true })